<template>
    <div>
      <MdTitle v-bind:Text="$t('Patient.PatientLabels')" />
      <b-row>
        <b-col lg="3" md="3" sm="12">
          <MdSelect
            v-bind:Label="$tc('Shared.Patient',2)"
            v-bind:Options="PatientsOptions"
            v-bind:Model="PatientModel"
            v-bind:FieldDescription="'patientname'"
            v-bind:FieldCode="'patientcode'"
            v-bind:Multiple="true"
            v-bind:AllowEmpty="true"
            :Input="ChangePatients"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdSelect
            ref="LabelTypeSelect"
            v-bind:Label="$t('Patient.LabelType')"
            v-bind:Options="labelSettings"
            v-bind:Model="labelSettingsModel"
            v-bind:FieldDescription="'templateCode'"
            v-bind:FieldCode="'templateCode'"
            v-bind:AllowEmpty="true"
            v-bind:isRequired="true"
            :Input="changeLabelSettings"/>
        </b-col>
      </b-row>
         <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>

        </div>
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('Patient.PatientLabels')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="LabelsReport"
          :ReportName="'LabelsReport'"
          :ReportTitle="$t('Patient.PatientLabels')"
          :IsAnAPIReport="true"
        />
    </DxPopup>

    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import PatientService from '@/services/patient.service'
    import LetterTemplatesService from '@/services/lettertemplates.service'
    import Utils from '../../../common/utils'
    import DBFunctions from '@/common/DBFunctions.js'
    import { EventBus } from '@/event-bus.js';

    export default Vue.extend({
        name: "PrintLabelsRep",
        mixins: [ ShowMessage, Utils, DBFunctions ],
        components: { DxPopup },
        data() {
            return {
                isReportVisible: false,
                SeeIncidentAdmin:false,
                reportParams: [],
                PatientsOptions: [],
                PatientModel: '',
                parameter:{
                  SearchCriteria:'',
                  PageNumber : null,
                  PageSize:null,
                  Status: true,
                },
                reportTitle: this.$t('Incident.IncReportTitle'),
                paramPatients: '',
                fullParam: {
                  PageSize:0,
                  PageNumber:0
                },
                labelSettings: [],
                labelSettingsModel: null
            }
        },
        methods: {

            changeLabelSettings(item) {
                this.labelSettingsModel = item;
            },

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
            },

            reportList() {
              this.checkExistFavorite('/app/reports/patients');
              this.$router.push({ name: "reportListPatient" }).catch(()=>{});
            },

            onClickShowReport() {
              if (!this.labelSettingsModel) {
                this.$refs.LabelTypeSelect.setValid(false);
                return;
              }
              this.$refs.LabelTypeSelect.setValid(true);
              this.reportParams = []

              this.reportParams.push({ paramName: 'codeList', paramValue: this.paramPatients})
              this.reportParams.push({ paramName: 'code', paramValue: this.labelSettingsModel.templateCode})


              this.isReportVisible = true
              this.$refs.LabelsReport.buildDocument(this.reportParams)
            },


            getLabelSettings(){
              LetterTemplatesService.getLabelSettings()
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0) {
                  this.labelSettings = response.data;
                }
              })
              .catch(error => {
                if (!error.response) {
                    // network error
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                } else {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });
            },

            getPatients(){
              PatientService.getAll(this.fullParam)
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0) {
                  this.PatientsOptions = response.data;
                  this.PatientsOptions.forEach(function(element) {
                      element.patientname = element.firstname + " " + element.lastname + " - "+element.patientcode;
                  });
                }
              })
              .catch(error => {
                if (!error.response) {
                    // network error
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                } else {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });
            },

            ChangePatients(item) {
              if(item != null){
                this.PatientModel = item;

                this.paramPatients = [];
                let selectedPatients = [];
                item.forEach(function(item) {
                  selectedPatients.push(item.patientcode);
                });
                this.paramPatients = selectedPatients;
              }else{
                this.PatientModel = null;
              }
            },
        },

        async created(){
        },

        mounted () {
          this.getPatients()
          this.getLabelSettings()
          EventBus.$on("ShowWeel", function (isShow) {
            isShow ? this.$emit('load', true) : this.$emit('load', false);
          }.bind(this));
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {
      height: 94% !important;
  }
</style>
